module.exports = __webpack_public_path__ + "static/img/kulian.dd30f62.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/kulian.png
// module id = +nJT
// module chunks = 2